import { FC, useState } from 'react';
import { getLocalStorage, setLocalStorage } from '@/common/localStorages';
import { TAnalyticArgs } from '@/containers/AnalyticsContainer';
import { Text } from '@mofid-securities/uikit';
import { Icon } from '@/components/atomic/Icon';
import Button from '@/components/Button';
import { Link } from '@/components/Link';
import { useVariant } from '@/unleash';
import { useBreakPointDown } from '@/hooks/breakPoint';
import { useGetFullPath } from '@/hooks/url';
import { classnames } from '@/utils/classnames';

export const SuggestionMenu: FC = () => {
  const { data, enabled: isSuggestionMenuFlagEnabled } = useVariant(
    'web.general.suggestionMenu'
  );
  const [isVisible, setIsVisible] = useState(true);
  const { fullPath } = useGetFullPath();

  const {
    link,
    linkId,
    linkShortTitle,
    linkTitle,
    title,
    icon,
    scrollTo,
    shouldHideAfterClick,
    paths,
  } = data || {};

  const linkAnalytics = linkId ? ([linkId] as TAnalyticArgs) : undefined;

  const isMdDown = useBreakPointDown('md');

  const onClickHandler = () => {
    if (linkId) {
      if (scrollTo) {
        const element = document.getElementById(scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
      if (shouldHideAfterClick) {
        setLocalStorage('visitedSuggestionMenuLinkId', linkId);
        setIsVisible(false);
      }
    }
  };

  const isPathMatched =
    paths && paths.length > 0 && fullPath ? paths.includes(fullPath) : true;

  const enabled =
    isSuggestionMenuFlagEnabled &&
    isPathMatched &&
    getLocalStorage('visitedSuggestionMenuLinkId') !== linkId;

  const content = isMdDown ? (
    <div
      className={classnames(
        'flex h-[60px] items-center justify-between rounded-t-xl border-b-[1px] border-[#DFE8EC] bg-white px-5',
        !isVisible && 'hidden'
      )}
    >
      <Text
        className="flex items-center gap-x-1 text-mofidblue-filled-primary-enabled"
        component="h3"
        size="sm"
        weight="medium"
      >
        {title}
        {icon && <Icon icon={icon} size={16} />}
      </Text>
      <Link
        analytics={linkAnalytics}
        href={link!}
        id={linkId}
        onClick={onClickHandler}
      >
        <div className="flex items-center gap-x-1 !text-sm !font-medium text-link-filled-primary-enabled">
          {linkTitle}
          <Icon icon="chevron_left" size={18} />
        </div>
      </Link>
    </div>
  ) : (
    <div className="mt-4 flex flex-col items-center justify-center gap-y-4 rounded-2xl bg-white p-4 text-center">
      <Text
        className="text-gray-filled-primary-enabled"
        component="h3"
        size="sm"
        weight="medium"
      >
        {title}
        {icon && <Icon className="mr-1" icon={icon} size={16} />}
      </Text>
      <Link
        classNames={{
          root: 'w-full',
        }}
        href={link!}
      >
        <Button
          analytics={linkAnalytics}
          className=" !h-8 w-full !bg-mofidgreen-filled-secondary-enabled !text-xs !text-mofidgreen-filled-primary-enabled hover:!bg-mofidgreen-filled-secondary-hovered"
          endIconName="arrow_left"
          endIconProps={{
            size: 20,
            icon: 'arrow_left',
          }}
          id={linkId}
          isFullWidth
        >
          <span className="md:hidden lg:inline">{linkTitle}</span>
          <span className="hidden md:inline lg:hidden">{linkShortTitle}</span>
        </Button>
      </Link>
    </div>
  );

  return enabled ? content : null;
};
